import { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Popconfirm,
  message,
  Modal,
  Spin,
  Space,
  Table,
  Typography
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import { request } from "../services/api";

const { Title, Text } = Typography;

const CommercialRejection = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    start();
    // eslint-disable-next-line
  }, []);

  const start = async () => {
    try {
      const params = ``;
      setLoading(true);
      const response = await request(
        `/management/commercialrejection/retrieve?${params}`,
        {
          method: "GET"
        }
      );
      if (response.length > 0) {
        const indexedData = response.map((item, index) => ({
          ...item,
          key: item.id || index
        }));
        setData(indexedData);
      }
      setLoading(false);
    } catch (error) {
      message.error("No se pudo iniciar la consulta");
      setLoading(false);
    }
  };

  const handleCreate = async (values) => {
    try {
      setLoading(true);
      let datosAEnviar = { ...values };
      await request("/management/commercialrejection/create", {
        method: "POST",
        body: JSON.stringify(datosAEnviar)
      });
      message.success(`Registro creado`);
      setIsModalOpen(false);
      form.resetFields();
      start();
    } catch (error) {
      message.error("Error al crear contacto");
      console.log("option cannot be added");
    } finally {
      setLoading(false);
      console.log("option added successfully");
    }
  };

  const handleDelete = async (recordAEliminar) => {
    const { code } = recordAEliminar;
    try {
      setLoading(true);
      await request(
        `/management/commercialrejection/remove?code=${code}`,
        {
          method: "DELETE"
        }
      );
      start();
    } catch (error) {
      message.error("No se pudo eliminar");
    } finally {
      setLoading(false);
      console.log("option removed successfully");
    }
  };

  const columns = [
    {
      title: "Codigo",
      dataIndex: "code",
      key: "code",
      width: 100
    },
    { title: "Descripción", dataIndex: "description", key: "description" },
    {
      title: "Remover",
      key: "remover",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Popconfirm
            title="Eliminar opción de menú"
            description={`¿Estás seguro de que deseas eliminar ese código?. Esta acción es irreversible`}
            onConfirm={() => handleDelete(record)}
            okText="Sí, eliminar"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <Title level={2} style={{ margin: 0 }}>
          Tabla de códigos de rechazo comercial
        </Title>
        <Text type="secondary">
          Alta y baja de los motivos de rechazo de la fuerza comercial.
        </Text>
        <br />
        <Space style={{ marginTop: 16, marginBottom: 16 }}>
          <Button icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
            Nueva Opción
          </Button>
        </Space>
        <Card>
          <Spin spinning={loading} description="Cargando información...">
            <Table
              dataSource={data}
              columns={columns}
              rowKey="key"
              pagination={false}
              tableLayout="fixed"
            />
          </Spin>
        </Card>
        <Modal
          title="Agregar Motivo de Rechazo"
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={() => form.submit()}
          confirmLoading={loading}
          okText="Guardar"
          cancelText="Cancelar"
          okButtonProps={{ style: { background: "#000" } }}
          forceRender={true}
        >
          <Form form={form} layout="vertical" onFinish={handleCreate}>
            <Form.Item
              name="code"
              label="Código"
              rules={[
                {
                  required: true,
                  message: "Ingresa el código del motivo de rechazo"
                }
              ]}
            >
              <Input placeholder="B404" style={{ width: "70px" }} />
            </Form.Item>
            <Form.Item
              name="description"
              label="Descripción"
              rules={[
                {
                  required: true,
                  message: "Ingresa la descripción del motivo de rechazo."
                }
              ]}
            >
              <Input placeholder="ejemplo: Servicio no disponible" />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default CommercialRejection;
